import { css } from '@emotion/react';
import styled from '@emotion/styled';

export type ToolbarVariant = 'large' | 'normal' | 'dense';

export const TOOLBAR_VARIANT = {
  LARGE: 'large',
  NORMAL: 'normal',
  DENSE: 'dense',
};

export type ToolbarProps = {
  variant?: ToolbarVariant;
  disableGutters?: boolean;
};

const applyMainStyles =
  ({
    variant,
    disableGutters,
  }: Pick<ToolbarProps, 'variant' | 'disableGutters'>) =>
  (theme) => {
    const defaultStyle = css(theme.toolbar.defaultStyles);
    const variantStyle = css(theme.toolbar[variant]);

    const styles = [defaultStyle, variantStyle];

    if (!disableGutters) {
      styles.push(css(theme.toolbar.gutters));
    }

    return css(...styles);
  };

export const Toolbar = styled.div<ToolbarProps>(
  ({ variant = 'large', disableGutters, theme }) => ({
    ...applyMainStyles({ variant, disableGutters })(theme),
  })
);
